import { FuelType } from '../enums/fuel-type.enum';

export const FuelTypeTranslations: Record<FuelType, string> = {
  [FuelType.PETROL]: 'petrol',
  [FuelType.DIESEL]: 'diesel',
  [FuelType.ELECTRIC]: 'electric',
  [FuelType.HYBRID]: 'hybrid',
};

